import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, Project, Tiers } from '../../models';

@Injectable({
    providedIn: 'root'
})
/* istanbul ignore file */
export class LicenseTiersDataService extends HttpBaseService {

    private route = environment.api + 'license-tiers/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getLicenseTiers(): Observable<Tiers> {
        const url = `${this.route}`;
        return this.httpGet(url);
    }

    licenseTierUpgradeRequest(currentApp: App, currentProject: Project, upgradeRequest: FormData): Observable<void> {
        const url = `${this.route}apps/${currentApp.id}/projects/${currentProject.id}/license-tier-upgrade-request`;
        return this.httpPost(url, upgradeRequest);
    }
}
